import { siteContentDefaults } from './content/defaults/site-content'
import type { ClientCopy } from './site-settings-context'

export function resolveClientCopy(copy?: ClientCopy): ClientCopy {
  return copy ?? { siteLabels: siteContentDefaults.siteLabels }
}
